<template>
  <div :class="getClasses()" @mouseleave="handleTimeBarOut">
    <div class="wrapper">
      <n-play-pause-button
        :is-playing="isPlaying"
        @play="handlePlay"
        @pause="handlePause" />
    </div>
    <n-time-bar
      :current="current"
      :buffered="buffered"
      :start="start"
      :end="end"
      @over="handleTimeBarOver"
      @out="handleTimeBarOut"
      @change="handleTimeBarChange" />
    <div class="wrapper">
      <n-spinner v-if="isBuffering" />
    </div>
  </div>
</template>

<style lang="scss" scoped>

.control-bar {
  display: grid;
  grid-gap: $spacing--m;
  grid-template-columns: $spacing--m 1fr $spacing--m;
  align-items: center;
  height: $height--controlbar;
  padding: 0 $spacing--m;
}

</style>

<script>
import TimeBar from './TimeBar'
import PlayPauseButton from './PlayPauseButton'
import Spinner from './Spinner'

export default {
  props: {
    customClass: {
      type: String
    },
    isPlaying: {
      type: Boolean,
      default: false
    },
    isBuffering: {
      type: Boolean,
      default: true
    },
    current: {
      type: Number
    },
    buffered: {
      type: Number
    },
    start: {
      type: Number
    },
    end: {
      type: Number
    }
  },
  components: {
    'n-play-pause-button': PlayPauseButton,
    'n-time-bar': TimeBar,
    'n-spinner': Spinner
  },
  methods: {
    getClasses () {
      return ['control-bar', this.$props.customClass]
    },
    handleTimeBarOut () {
      this.$emit('out')
    },
    handleTimeBarOver (data) {
      this.$emit('over', data)
    },
    handleTimeBarChange (data) {
      this.$emit('seek', data)
    },
    handlePlay (e) {
      this.$emit('play')
    },
    handlePause (e) {
      this.$emit('pause')
    }
  }
}
</script>
